import { useLayoutEffect } from 'react';

const PRIVACY_POLICY = {
  title: '개인정보처리방침',
  companyName: '주식회사 다이렉트컴즈',
  serviceName: '다이렉트결혼준비',
  effectiveDate: '2024-11-01',
  sections: [
    {
      title: '제1조 개인정보의 수집 및 이용에 관한 안내',
      blocks: [
        '회사는 서비스 이용에 필요한 최소한의 개인정보를 수집하고 있습니다.',
        '회사는 다양한 서비스 제공을 위해 이용자에게 동의를 받고 추가적인 개인정보를 수집할 수 있습니다.',
      ],
      groups: [
        {
          title: '비회원',
          items: [
            '광고제휴 문의대응: 회사명, 성명, 이메일, 전화번호 / 수집일부터 3개월까지',
            '다이렉트 웨딩 문의응대: 이름, 전화번호, 문의내용 / 수집일부터 3개월까지',
          ],
        },
        {
          title: '회원가입 및 서비스 이용',
          items: [
            '회원가입 및 이용자 식별: 이름, 이메일, 비밀번호, 전화번호 / 회원탈퇴까지',
            'SNS 간편 회원가입 및 로그인: 구글·페이스북 이름, 이메일 주소, 프로필 사진 / 회원탈퇴까지',
          ],
        },
        {
          title: '마케팅',
          items: [
            '혜택 및 이벤트 등 마케팅 관련 사항 안내: 이름, 이메일, 휴대전화번호 / 동의철회까지',
          ],
        },
        {
          title: '서비스 운영 및 관리',
          items: [
            '포인트 환급 신청 및 관리: 네이버 아이디, 이름, 계좌번호, 예금주명 / 관련법령에 따른 기간까지',
            '다이렉트 웨딩 카페 가입 및 등업 신청: 네이버ID, 카페닉네임, 프로필 이미지, 이름, 전화번호 / 회원탈퇴까지',
            '견적요청 및 상담: 이름, 전화번호, 네이버ID, 카페닉네임, 문의내용 / 수집일부터 3개월까지',
            '포인트 사이트 회원가입 및 이용자 식별: 이메일, 이름, 아이디, 패스워드, 카페닉네임, 핸드폰 번호 / 회원탈퇴까지',
            '상담 및 방문 신청, 문의 응대: 이름, 전화번호, 문의내용 / 요청 사항 완료 후 3개월까지',
            '계약 진행 및 관련 사항 안내: 성명, 연락처, 계약내용 / 계약종료 후 3년까지',
          ],
        },
        {
          title: '주민등록번호',
          items: [
            '처리자: 주식회사 다이렉트컴즈',
            '처리목적: 사업소득세 원천징수, 원천징수 내역 신고 및 납세',
            '필수항목: 주민등록번호',
            '보유·이용기간: 세금 신고 및 납세 처리 시까지',
            '관련법규: 소득세법 제21조, 제127조, 제164조',
          ],
        },
      ],
    },
    {
      title: '제2조 민감정보의 처리에 관한 사항',
      blocks: ['회사는 이용자의 민감한 개인정보를 수집하지 않습니다.'],
    },
    {
      title: '제3조 만 14세 미만 아동의 개인정보 처리에 관한 사항',
      blocks: ['회사는 만 14세 미만 아동에게 당사의 서비스를 제공하지 않으며 이와 관련한 개인정보를 수집하지 않습니다.'],
    },
    {
      title: '제4조 개인정보 자동수집 장치의 설치와 운영거부에 관한 사항',
      blocks: [
        '회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 쿠키(cookie)를 사용합니다.',
        '회사는 서비스 이용과정에서 정보주체에게 최적화된 맞춤형 서비스 및 혜택, 온라인 맞춤형 광고 등을 제공하기 위하여 행태정보를 수집·이용하고 있습니다.',
        '이용자는 웹브라우저 설정을 통해 쿠키 저장 또는 행태정보 수집을 거부할 수 있습니다. 단, 설정 변경은 웹사이트 자동로그인 등 일부 서비스 이용에 영향을 미칠 수 있습니다.',
      ],
      groups: [
        {
          title: '문의',
          items: ['행태정보 관련 문의 및 거부권 행사: meharoad@naver.com'],
        },
      ],
    },
    {
      title: '제5조 개인정보의 보유·이용기간 및 파기',
      blocks: [
        '회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.',
        '개인정보를 수집한 이용목적을 달성한 경우 회사는 이용자의 모든 개인정보를 삭제합니다.',
        '단, 관계 법령에서 개인정보를 보존해야 할 필요가 있는 경우 해당 법률의 규정에 따릅니다.',
      ],
      groups: [
        {
          title: '관련 법령에 따른 의무 보존기간',
          items: [
            '계약 또는 청약철회 등에 관한 기록: 5년',
            '대금결제 및 재화 등의 공급에 관한 기록: 5년',
            '소비자의 불만 또는 분쟁처리에 관한 기록: 3년',
            '표시·광고에 관한 기록: 6개월',
            '세법이 규정하는 모든 거래에 관한 장부 및 증빙서류: 5년',
            '접속에 관한 기록보존: 3개월',
          ],
        },
      ],
    },
    {
      title: '제6조 개인정보 처리 위탁',
      blocks: [
        '회사는 원활한 개인정보 업무처리를 위하여 일부 개인정보 처리 업무를 위탁하고 있으며, 위탁 계약 체결 시 관련 법령에 따라 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.',
      ],
      groups: [
        {
          title: '수탁사 및 위탁업무',
          items: [
            '㈜카카오: 상담 플랫폼',
            'NICE평가정보㈜: 본인확인',
            'Tally: 데이터 수집폼 기능',
            '오내피플(캐치시큐): 캐치폼 개인정보 관리, 본인인증 및 전자서명 서비스',
          ],
        },
      ],
    },
    {
      title: '제7조 개인정보의 제3자 제공',
      blocks: [
        '회사는 정보주체의 개인정보를 명시한 범위 내에서만 처리하며, 이용자의 별도 사전동의 또는 관련 법령의 특별한 요구가 발생하는 경우에만 개인정보를 제3자에게 제공합니다.',
      ],
      groups: [
        {
          title: '사전 동의를 받아 제3자에게 제공되는 정보',
          items: [
            '고객 및 다이렉트컴즈에 의해 선택된 제휴업체: 예약 및 진행 관리, 상담 및 방문 신청자 관리',
            '국세청·지방자치단체: 원천징수내역 신고 및 납세',
            '웨딩박람회 주최업체: 박람회 참여자 식별, 박람회 운영 및 관리',
          ],
        },
        {
          title: '사전 동의 없이 제공될 수 있는 경우',
          items: [
            '특정 개인을 식별할 수 없는 통계작성, 학술연구 또는 시장조사',
            '관계법령에 의하여 국가기관으로부터 요구받은 경우',
            '범죄 수사 목적 또는 관계법령에서 정한 절차에 따른 요청',
            '재난, 감염병, 급박한 생명·신체 위험 등 긴급상황',
          ],
        },
      ],
    },
    {
      title: '제8조 개인정보의 국외 이전',
      blocks: [
        '회사는 개인정보를 국외의 다른 사업자에게 제공하지 않습니다. 다만, 정보통신서비스 제공에 관한 계약 이행 및 이용자 편의 증진 등을 위하여 일부 개인정보 처리 업무를 국외에 전송하고 있습니다.',
      ],
      groups: [
        {
          title: '국외 이전 개인정보',
          items: [
            '목적: 데이터 수집폼 기능',
            '항목: 이름, 전화번호, 문의내용',
            '이전 방법: 서비스 제공 시 암호화된 네트워크를 통해 전송',
            '보유기간: 계약 종료 또는 이용 목적 달성 후 3개월까지',
            '업체 및 국가: Tally / 벨기에',
            '연락처: hello@tally.so',
          ],
        },
      ],
    },
    {
      title: '제9조 개인정보의 안전성 확보조치',
      blocks: [
        '회사는 이용자의 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 필요한 기술적·관리적 및 물리적 조치를 하고 있습니다.',
      ],
      groups: [
        {
          title: '보호조치',
          items: [
            '개인정보 취급 직원의 최소화 및 교육',
            '내부관리계획의 수립 및 시행',
            '접속기록의 보관 및 위변조 방지',
            '개인정보의 암호화',
            '해킹 등에 대비한 기술적 대책',
            '개인정보 처리시스템 접근권한 관리',
          ],
        },
      ],
    },
    {
      title: '제10조 이용자 및 법정대리인의 권리와 그 행사 방법',
      blocks: ['회사는 이용자 또는 법정대리인의 개인정보 권리를 보호하기 위해 아래와 같이 행사 방법을 마련하고 있습니다.'],
      groups: [
        {
          title: '이용자의 권리 및 행사방법',
          items: [
            '열람·수정: 마이페이지 > 내정보',
            '회원탈퇴: 고객센터 문의',
            '서면, 전자우편 등을 통한 처리 정지 및 삭제 요구',
            '회사는 정정 또는 삭제 요청이 완료되기 전까지 해당 개인정보를 이용하거나 제공하지 않습니다.',
          ],
        },
        {
          title: '법정대리인의 권리 및 행사방법',
          items: [
            '대리인이 권리를 행사하는 경우 개인정보보호법 시행규칙 별지 제11호 서식의 위임장을 제출해야 합니다.',
            '회사는 열람, 정정·삭제, 처리정지 요구 시 정당한 대리인 여부를 확인합니다.',
          ],
        },
      ],
    },
    {
      title: '제11조 개인정보 보호책임자 및 이용자 권익침해에 대한 구제방법',
      blocks: [
        '회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 이용자의 불만처리 및 피해구제 등을 위하여 개인정보 보호책임자를 지정하고 있습니다.',
      ],
      groups: [
        {
          title: '개인정보 보호책임자',
          items: ['성명: 장용준', '직책: 대표이사', '연락처: meharoad@naver.com'],
        },
        {
          title: '권익침해 관련 도움받을 수 있는 기관',
          items: [
            '개인정보 침해신고센터: privacy.kisa.or.kr / 118',
            '개인정보 분쟁조정위원회: www.kopico.go.kr / 1833-6972',
            '대검찰청 사이버범죄수사단: www.spo.go.kr / 1301',
            '경찰청 사이버안전국: ecrm.police.go.kr / 182',
            '중앙행정심판위원회: www.simpan.go.kr',
          ],
        },
      ],
    },
    {
      title: '제12조 개인정보 처리방침 변경에 관한 사항',
      blocks: [
        '개인정보 처리방침은 시행일로부터 적용되며, 관련 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 지체없이 홈페이지를 통하여 고지할 것입니다.',
      ],
    },
  ],
};

function buildPrivacyPolicyText() {
  const lines = [
    PRIVACY_POLICY.title,
    '',
    `${PRIVACY_POLICY.companyName}가 운영하는 ${PRIVACY_POLICY.serviceName}은 개인정보보호법 제30조에 따라 이용자의 개인정보 및 권익을 보호하고 관련 고충과 불만을 신속하게 처리하기 위하여 본 방침을 수립하여 운영합니다.`,
    '',
    `시행일: ${PRIVACY_POLICY.effectiveDate}`,
    '',
  ];

  PRIVACY_POLICY.sections.forEach((section) => {
    lines.push(section.title);
    lines.push('');

    section.blocks.forEach((block) => {
      lines.push(block);
      lines.push('');
    });

    section.groups?.forEach((group) => {
      lines.push(group.title);
      group.items.forEach((item) => {
        lines.push(`- ${item}`);
      });
      lines.push('');
    });
  });

  return lines.join('\n').trim();
}

function isHeadingLine(line: string) {
  return line === PRIVACY_POLICY.title || /^제\d+조/.test(line);
}

function isSectionSubheadingLine(line: string) {
  return [
    '비회원',
    '회원가입 및 서비스 이용',
    '마케팅',
    '서비스 운영 및 관리',
    '주민등록번호',
    '문의',
    '관련 법령에 따른 의무 보존기간',
    '수탁사 및 위탁업무',
    '사전 동의를 받아 제3자에게 제공되는 정보',
    '사전 동의 없이 제공될 수 있는 경우',
    '국외 이전 개인정보',
    '보호조치',
    '이용자의 권리 및 행사방법',
    '법정대리인의 권리 및 행사방법',
    '개인정보 보호책임자',
    '권익침해 관련 도움받을 수 있는 기관',
  ].includes(line);
}

function TermText({ text }: { text: string }) {
  return (
    <div className="whitespace-pre-wrap break-keep font-sans text-[14px] leading-[1.9] text-[#2E2F33] md:text-[15px]">
      {text.trim().split('\n').map((line, index) => {
        const trimmedLine = line.trim();

        if (trimmedLine === '') {
          return <br key={index} />;
        }

        if (isHeadingLine(trimmedLine)) {
          return (
            <p key={index} className="mt-6 font-bold text-[#17171A] first:mt-0">
              {line}
            </p>
          );
        }

        if (isSectionSubheadingLine(trimmedLine)) {
          return (
            <p key={index} className="font-bold text-[#17171A]">
              {line}
            </p>
          );
        }

        return <p key={index}>{line}</p>;
      })}
    </div>
  );
}

export default function PrivacyTermPage() {
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <div className="min-h-dvh bg-white pt-16">
      <div className="mx-auto max-w-[900px] px-5 py-10 md:px-8 md:py-14">
        <h1 className="mb-8 text-[28px] font-bold text-[#17171A] md:text-[36px]">
          개인정보처리방침
        </h1>
        <TermText text={buildPrivacyPolicyText()} />
      </div>
    </div>
  );
}
